import React, { useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";

const DelayLink = ({
  to,
  replace = false,
  delay = 0,
  onDelayStart = () => {},
  onDelayEnd = () => {},
  clickAction,
  ...props
}) => {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const handleClick = (e) => {
    if (clickAction) {
      clickAction();
    }
    onDelayStart(e, to);

    if (e.defaultPrevented) {
      return;
    }
    e.preventDefault();

    timeoutRef.current = setTimeout(() => {
      if (replace) {
        navigate(to, { replace: true });
      } else {
        navigate(to);
      }
      onDelayEnd(e, to);
    }, delay);
  };

  return <Link {...props} to={to} onClick={handleClick} />;
};

export default DelayLink;
